export default "__VITE_ASSET__BAl65TIo__"